export default "__VITE_PUBLIC_ASSET__2d059a22__"